import React from "react";
import { TESTIMONIALS, FIRM } from "../data/content";
import { ArrowUpRight } from "lucide-react";

export default function Recommendations({ compact = false, showLinkedInLink = true }) {
  const items = compact ? TESTIMONIALS.slice(0, 3) : TESTIMONIALS;

  return (
    <section
      className={`relative z-10 ${compact ? "py-20" : "py-28 md:py-32"} bg-[#050A14]`}
      data-testid="recommendations"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 mb-14 items-end">
          <div className="lg:col-span-7">
            <p className="text-sm font-500 tracking-[0.3em] uppercase text-[#D95A41] mb-5">
              Recommendations
            </p>
            <h2 className="text-3xl md:text-5xl font-900 tracking-tightest leading-[1.02] text-[#F2EFE9]">
              {compact ? "What clients & partners say." : "In their own words."}
            </h2>
          </div>
          <div className="lg:col-span-5 lg:pb-2">
            <p className="text-base text-[#94A3B8] leading-relaxed" style={{ textAlign: "left" }}>
              Endorsements from clients, partners and senior counsel who have worked directly with Shray across India, Singapore and the wider APAC region.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <div
              key={i}
              className="rounded-2xl border border-white/10 bg-[#0B132B]/50 p-8 flex flex-col hover:border-[#D95A41]/40 transition-colors"
              data-testid={`recommendation-${i}`}
            >
              <svg width="32" height="24" viewBox="0 0 32 24" className="text-[#D95A41] mb-5" fill="currentColor" aria-hidden="true">
                <path d="M0 24V13.6C0 9.6 0.906667 6.30667 2.72 3.72C4.56 1.24 7.09333 0 10.32 0V4.68C8.66667 4.68 7.34667 5.34667 6.36 6.68C5.37333 8.01333 4.88 9.86667 4.88 12.24H10.08V24H0ZM17.92 24V13.6C17.92 9.6 18.8267 6.30667 20.64 3.72C22.48 1.24 25.0133 0 28.24 0V4.68C26.5867 4.68 25.2667 5.34667 24.28 6.68C23.2933 8.01333 22.8 9.86667 22.8 12.24H28V24H17.92Z" />
              </svg>
              <p className="text-[15px] text-[#F2EFE9]/90 leading-relaxed flex-1">
                {t.text}
              </p>
              <div className="mt-6 pt-5 border-t border-white/10">
                <p className="font-700 text-[#F2EFE9]">{t.name}</p>
                <p className="text-sm text-[#94A3B8] mt-0.5" style={{ textAlign: "left" }}>{t.role}</p>
              </div>
            </div>
          ))}
        </div>

        {showLinkedInLink && (
          <div className="mt-12 flex justify-center">
            <a
              href={FIRM.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="recommendations-linkedin"
              className="inline-flex items-center gap-2 text-sm font-700 tracking-[0.15em] uppercase text-[#94A3B8] hover:text-[#D95A41] transition-colors"
            >
              More recommendations on LinkedIn <ArrowUpRight size={16} />
            </a>
          </div>
        )}
      </div>
    </section>
  );
}
